

































import {
  updateCarrierInvoicingTerms,
  updateLastShownPaymentPopUpDate,
  fetchPersonDetails,
  paymentPeriodOptions
} from '@/services/payment-period-update'
import { mapMutations, mapState } from 'vuex'
import moment from 'moment'
import { applyCustomErrorConfig } from '@/custom-errors'

export default {
  props: {
    isShown: { default: false, type: Boolean }
  },
  data() {
    return {
      proposedPaymentPeriod: null,
      periodOptions: [],
      selectedPeriod: {},
      sconto: null,
      personDetails: null,
      show: this.isShown
    }
  },
  computed: {
    ...mapState(['currentCarrierCompany']),
    selectedPeriodFromDropdown: {
      get() {
        return this.selectedPeriod
      },
      set(value) {
        if (value) {
          this.proposedPaymentPeriod = value.paymentDays
          this.sconto = value.discountPercentage
          this.selectedPeriod = value
        }
      }
    },
    isOnlyOneOptionAvailable() {
      return this.periodOptions.length === 1
    },
    paymentPeriodDescription() {
      return this.$t('updatePaymentPeriod.text', {
        numberOfPaymentPeriodDays: this.proposedPaymentPeriod,
        sconto: this.sconto
      })
    }
  },
  watch: {
    isShown(value) {
      this.show = value
    }
  },
  async created() {
    await Promise.all([fetchPersonDetails(), paymentPeriodOptions()]).then(response => {
      this.personDetails = response[0]
      this.periodOptions = this.buildPeriodOptions(response[1])
    })

    this.selectedPeriod = this.periodOptions.find(item => item.defaultSelection === true)
    this.sconto = this.selectedPeriod.discountPercentage
  },
  methods: {
    ...mapMutations(['setCarrierCompanyPaymentDays']),
    buildPeriodOptions(items) {
      return items.map(({ paymentDays, discountPercentage, defaultSelection }) => ({
        paymentDays,
        name: this.buildDynamicOption(paymentDays, discountPercentage),
        discountPercentage,
        defaultSelection
      }))
    },
    buildDynamicOption(paymentDays, sconto) {
      return this.$t('updatePaymentPeriod.paymentOption', {
        paymentDays,
        sconto
      })
    },
    close() {
      this.show = false
    },
    open() {
      this.show = true
    },
    showSuccessModal() {
      this.alertModal.showSuccessMessage(
        this.$t('updatePaymentPeriod.sweetAlert.successTitle'),
        this.$t('updatePaymentPeriod.sweetAlert.successMsg')
      )
    },
    showErrorModal() {
      this.alertModal.showErrorMessage(
        this.$t('updatePaymentPeriod.sweetAlert.errorMsg.title'),
        this.$t('updatePaymentPeriod.sweetAlert.errorMsg.description'),
        applyCustomErrorConfig
      )
    },
    async updatePaymentPeriod() {
      try {
        const selectedPeriod = this.selectedPeriod
        await updateCarrierInvoicingTerms(this.currentCarrierCompany.id, {
          paymentDays: selectedPeriod.paymentDays,
          discountPercentage: selectedPeriod.discountPercentage
        })
        this.setCarrierCompanyPaymentDays(selectedPeriod.paymentDays)
        this.showSuccessModal()
      } catch {
        this.showErrorModal()
      } finally {
        this.close()
      }
    },
    async onShow() {
      const currentDate = moment().toISOString()
      const { personDetails } = this
      try {
        await updateLastShownPaymentPopUpDate({
          lastShownUpdatePaymentPopUp: currentDate,
          firstName: personDetails.firstName,
          lastName: personDetails.lastName
        })
      } catch (e) {
        // TODO: log the error
      }
    },
    handleClose() {
      this.close()
    },
    async handleClickConfirm() {
      if (this.selectedPeriod.value === 30) {
        this.handleClose()
      } else {
        this.updatePaymentPeriod()
      }
    }
  }
}
